module.exports = __webpack_public_path__ + "static/media/schuettler_ohne.3e082b0b.jpg";